<template>
  <div>
    <!-- 弹窗 -->
    <el-dialog title="售后处理" :visible.sync="dialogVisible" @close="onCancel">
      <el-form label-width="150px" label-position="right" :model="localDataForm" ref="ruleForm" :rules="rules">
        <el-row>
          <el-col :span="11">
            <el-form-item label="售后单号">
              <el-input v-model="ruleForm.refundCode" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="退款金额">
              <el-input v-model="ruleForm.refundAmount" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="售后理由">
              <el-input type="textarea" resize="none" :rows="3" v-model="ruleForm.refundMsg" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="处理售后">
              <el-select v-model="handleTypeVal" placeholder="请选择" clearable>
                <el-option v-for="item in handleType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="handleTypeVal == 2">
          <el-col :span="22">
            <el-form-item label="拒绝原因" prop="refuseMsg">
              <el-input type="textarea" :maxlength="50" :rows="3" resize="none" placeholder="请输入拒绝原因"
                v-model="localDataForm.refuseMsg" show-word-limit></el-input>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" plain @click="onCancel">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>


</template>

<script>
export default {
  props: {
    // 接受父级组件的显示标记，用于被watch
    showFlag: {
      type: Boolean
    },
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 处理售后类型
      handleType: [
        {
          value: '1',
          label: '同意退款'
        }, {
          value: '2',
          label: '拒绝退款'
        },
      ],
      //  prop 值的局部数据属性  
      localDataForm: this.ruleForm,
      rules: {
        refuseMsg: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' },
        ],
      },
      handleTypeVal: '',//处理售后
      picUrl: [],
    }
  },
  watch: {
    // 观察父级组件的传值
    showFlag(newVal) {
      this.dialogVisible = newVal
    },
  },
  created() {

  },
  methods: {
    // 弹窗输入(优化)
    async submitForm(formName) {
      try {
        // 校验表单 
        await new Promise((resolve, reject) => {
          this.$refs[formName].validate(valid => {
            if (!valid) {
              reject(new Error('表单校验失败')); // 拒绝Promise并传递错误  
            } else {
              resolve(); // 校验成功，解决Promise  
            }
          });
        });
        // 准备要发送的数据  
        const data = {
          orderReturnId: this.ruleForm.orderRefundId,
          refuseMsg: this.localDataForm.refuseMsg || null,//拒绝原因
          status: this.handleTypeVal,//状态：1成功（通过）；2售后拒绝
        };

        // console.log('准备要发送的数据 ', data);
        if (this.handleTypeVal) {
          // 根据状态决定是退款还是拒绝退款
          let response = await this.$axios.post(this.$api.productRefundOrderHandle, data);
          // 处理响应结果
          const { code } = response;
          if (code == 100) {
            this.$message({ message: '恭喜你，处理成功!', type: 'success' });
            this.onCancel();//重置+关闭弹窗 
          }
        } else {
          this.$message.error('请选择售后处理类型！');
        }

      } catch (error) {
        console.log(error);
      }
    },
    // 检验重置
    resetForm() {
      this.handleTypeVal = '';//处理类型恢复
      this.localDataForm = {};//清空对象
      this.$refs.ruleForm.resetFields();
    },

    // 触发父级组件的closeChildDialog
    onCancel() {
      this.resetForm()//重置校验
      this.$emit('closeChildDialog')
    },
  },
}
</script>

<style scoped lang='scss'></style>
